import { AppliedFilterPills } from '@rocco/ui/filter-sort/components/AppliedFilterPills';
import type { AppliedFilterItem } from '@modules/search/type/filter-state';

interface ProfessionalAppliedFiltersProps {
    filterItems: AppliedFilterItem[];
    onClearAll: () => void;
    theme?: 'light' | 'dark';
}

/**
 * {@link AppliedFilterPills} wired to the legacy web filter system the
 * professional item tabs run on. `dark` inverts the pills for the Projects
 * tab's dark editorial surface.
 */
export const ProfessionalAppliedFilters = ({
    filterItems,
    onClearAll,
    theme = 'light',
}: ProfessionalAppliedFiltersProps) => (
    <AppliedFilterPills
        items={filterItems.map((item) => ({
            // Two selections from the same filter group share a key, so
            // qualify it with the label.
            id: `${item.key}-${item.label}`,
            label: item.label,
            onRemove: () => item.action(),
        }))}
        onClearAll={onClearAll}
        theme={theme}
        className="pt-[1.5rem]"
    />
);
